"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _select = require("baseui/select");

var _react = _interopRequireWildcard(require("react"));

var _MultiOptionContent = _interopRequireDefault(require("./MultiOptionContent"));

var _SelectArrow = _interopRequireDefault(require("./SelectArrow"));

var _style = require("./style");

var _multiStyle = require("./multi-style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This is a basic Select component. It's a thin wrapper around the
 * [baseui select](https://baseweb.design/components/select/), so it supports
 * many of the same props.
 *
 * Note that the `value` prop and `value` arg in `onChange` are always arrays of options,
 * even if there's only one value in the single select case. This is to keep the interface
 * consistent between single and multi select.
 */
const MultiSelect = props => {
  const {
    placeholder,
    onChange,
    overrides,
    value = [],
    zIndex,
    ...selectProps
  } = props;
  const inputPlaceholder = value.length > 0 ? `${value.length} ${value.length === 1 ? 'item' : 'items'} selected` : placeholder !== null && placeholder !== void 0 ? placeholder : 'Select...';
  const onSelectChange = (0, _react.useCallback)(({
    value
  }) => onChange === null || onChange === void 0 ? void 0 : onChange(value), [onChange]);
  return /*#__PURE__*/_react.default.createElement(_select.Select, _extends({
    multi: true,
    backspaceRemoves: false,
    clearable: false,
    closeOnSelect: false,
    deleteRemoves: false,
    filterOutSelected: false,
    onSelectResetsInput: false,
    labelKey: "label",
    onChange: onSelectChange,
    overrides: {
      ControlContainer: {
        style: _style.getContainerStyle
      },
      Dropdown: {
        style: _style.getDropdownStyle
      },
      DropdownListItem: {
        style: _style.getDropdownListItemStyle
      },
      InputContainer: {
        style: _multiStyle.inputContainerStyle
      },
      Input: {
        props: {
          placeholder: inputPlaceholder
        },
        style: props => ({ ...(0, _style.getInputStyle)(props),
          ...(0, _multiStyle.inputStyle)(props)
        })
      },
      OptionContent: {
        props: props => {
          const {
            children,
            ...rest
          } = props;
          return {
            children: /*#__PURE__*/_react.default.createElement(_MultiOptionContent.default, {
              isSelected: rest.$selected
            }, children),
            ...rest
          };
        },
        style: _style.getOptionContentStyle
      },
      Placeholder: () => null,
      Popover: {
        props: {
          overrides: {
            Body: {
              style: (0, _style.getPopoverBodyStyle)(zIndex)
            }
          }
        }
      },
      SelectArrow: _SelectArrow.default,
      MultiValue: () => null,
      ValueContainer: {
        style: _multiStyle.valueContainerStyle
      },
      ...(overrides || {})
    },
    valueKey: "value",
    value: value
  }, selectProps));
};

var _default = MultiSelect;
exports.default = _default;